<template>
    <div class="Voting">        
      <VotingForm v-if="renderComponent1" :InfoRange="this.dataVoting" :method="callVotar"/>      
      <VotingResult v-if="renderComponent2" :InfoRange="this.dataVoting" />   
      <div v-if="novoto" class="VotingResult">
        <div class="alert alert-warning">
            No se encuentran votaciones activas en este momento.
        </div>
      </div>   
    </div>    
</template>

<script>
import VotingForm from '@/components/Voting/VotingForm.vue'
import VotingResult from '@/components/Voting/VotingResult.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
    name: 'Voting',
    data () {
        return {    
            renderComponent1: false,
            renderComponent2: false,
            novoto: false,
            dataVoting: []
        }
    },
    components: {
        VotingForm,
        VotingResult,
    },
    methods: {
        callLoadData(){
            this.renderComponent1 = false
            this.renderComponent2 = false
            var totalinf = IberoHelpers.listVotingUser(this.$store, this.$session.get('IberoJWTLogin').idPerson)
            totalinf.then(Response => { 
                if(!Response.data){
                    this.callListVoto()
                }else{
                    if(Response.data.VotingUser.length >= 1){
                        this.dataVoting = Response.data
                        IberoHelpers.forceRerender2(this)
                    }else{
                        this.callListVoto();
                    }
                }
            })                          
        },
        callListVoto(){
            var totalinf = IberoHelpers.listVotingRange(this.$store)
            totalinf.then(Response => { 
                if(Response.data){
                    this.dataVoting = Response.data.VotingRange[0]
                    IberoHelpers.forceRerender1(this)                                        
                }else{
                    this.novoto = true
                }
            })            
        },
        callVotar(valvoto){
            let loader = this.$loading.show();
            var totalinf = IberoHelpers.addVotoUser(this.$store, this.$session.get('IberoJWTLogin').idPerson, valvoto)
            totalinf.then(Response => {                 
                this.callLoadData();
                loader.hide();
            })                           
        }
    },
    created: function () {   
        if (!this.$session.get('IberoJWTLogin')) {
            this.$router.push('Login')
        } else {
            this.callLoadData();
        }   
    }    
}
</script>

<style scoped>
.VotingResult{
    margin: 30px;
    padding: 20px;    
}
</style>